<template>
  <div class="transition">
    <BasicText size="h5">Quels frais voulez-vous ajouter ?</BasicText>
    <div class="transition-items">
      <BasicCheckbox
        v-for="item in fraisItems"
        :key="item.code"
        :label="item.intitule"
        :model-value="estRadionOn(item.code)"
        @update:model-value="updateOut(item.code)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { computed } from 'vue'
  import type { NatureFrais } from '@/features/domaine/types/opco'
  import type { LovDTO } from '@/features/api/extranet/dto/Lov'

  const props = defineProps<CarteProps<{ naturesFrais: NatureFrais[], lovFrais: LovDTO<NatureFrais> }, NatureFrais[]>>()
  const emits = defineEmits<CarteEvents<NatureFrais[]>>()

  const fraisItems = computed(() => props.in.lovFrais.filter(item => props.in.naturesFrais.includes(item.code)))

  const estRadionOn = (item: NatureFrais) => {
    return (props.out ?? []).includes(item)
  }

  const updateOut = (item: NatureFrais) => {
    let result = [...(props.out ?? [])]
    if (estRadionOn(item)) {
      result = result.filter(nature => item !== nature)
    } else {
      result.push(item)
    }

    const okPourValidation = result.length > 0
    emits('outChanged', okPourValidation, result)
  }
</script>
<style lang="less" scoped>
  @import '../../../ajouter/cartes/ChoixCarte.less';
</style>

